import { useTranslation } from "@src/hooks/useTranslation";
import React from "react";
import FakeBannerApp from "design-system/src/Components/FakeBannerApp/FakeBannerApp";
import Cookies from "js-cookie";
import { useConfiguration } from "@src/hooks/query/useConfiguration";
import useBackboneContext from "@src/backbone/provider/useBackboneContext";
import { useWebViewContext } from "@src/lib/WebView/WebViewContext";

const cookieKey = "fake-banner-app-close";

function getTarget() {
  const ua = navigator.userAgent;
  if (/iPhone|iPad|iPod/.test(ua)) {
    if (/CriOS|OPiOS|FxiOS/i.test(ua)) return "IOS";
  } else if (/Android/i.test(ua)) {
    return "ANDROID";
  }
  return null;
}

function requireOpening(
  closed: string | undefined,
  target: string | null,
  getConfiguration: any
) {
  if (!target) return false;
  const enabled = !!getConfiguration(`_FAKE_BANNER_APP_${target}_ENABLED_`, 1);
  if (!enabled) return false;
  const inapp = false; // Implement in-app detection if needed
  if (closed) {
    const closedDate = new Date(closed);
    const expireDays =
      parseInt(getConfiguration("_APP_INSTALL_COOKIE_DAY_EXPIRES_", "30")) ||
      30;
    const expireDate = new Date();
    expireDate.setDate(expireDate.getDate() - expireDays);
    if (closedDate > expireDate) return false;
  }
  return !inapp;
}

const FakeBannerSection = () => {
  const { t } = useTranslation("UI");
  const noteLabel = t("Note", "UI");
  const buttonLabel = t("Afficher", "UI");
  const { getConfiguration } = useConfiguration();
  const { app } = useBackboneContext();
  const { isWebView } = useWebViewContext();

  const [closed, setClosed] = React.useState<string | undefined>(() =>
    Cookies.get(cookieKey)
  );
  const [target, setTarget] = React.useState<string | null>(null);

  React.useEffect(() => {
    setTarget(getTarget());
  }, []);

  if (!requireOpening(closed, target, getConfiguration)) return null;

  const conf_prefix = `_FAKE_BANNER_APP_${target}`;
  const title = getConfiguration(`${conf_prefix}_TITLE_`, app.getShopName());
  const cta = getConfiguration(`${conf_prefix}_CTA_`, "-");
  const app_rating_value = parseFloat(
    getConfiguration(`${conf_prefix}_RATING_VALUE_`, "4.5")
  );
  const app_rating_count = parseInt(
    getConfiguration(`${conf_prefix}_RATING_COUNT_`, "0")
  );
  const url = getConfiguration(`${conf_prefix}_URL_`, "");
  const cookieExpires =
    parseInt(getConfiguration("_APP_INSTALL_COOKIE_DAY_EXPIRES_", "30")) || 30;
  const handleClose = () => {
    const now = new Date().toISOString();
    Cookies.set(cookieKey, now, { expires: cookieExpires });
    setClosed(now);
  };

  const handleOpen = () => {
    window.location.href = url;
  };

  return isWebView ? null : (
    <FakeBannerApp
      title={title}
      app_rating_value={app_rating_value}
      app_rating_count={app_rating_count}
      cta={cta}
      noteLabel={noteLabel}
      buttonLabel={buttonLabel}
      onClose={handleClose}
      onOpen={handleOpen}
    />
  );
};

export default FakeBannerSection;
